<template>

  <div>
    <article :key="id">
      <ControlPanel :title="site.title" :icon="'mdi mdi-file-document'" :links="links"></ControlPanel>

      <div class="container">
        <transition name="fade">
          <b-card class="mt-4 p-3">
            <div class="card-text" v-html="site.content"></div>
          </b-card>
        </transition>
      </div>
    </article>
  </div>



</template>


<script>
import ControlPanel from "@/components/base/ControlPanel";
import {mapGetters} from "vuex";
export default {
  name: 'Site',
  components: {
    ControlPanel
  },
  props: ['id'],
  data: function () {
    return {
      site: {
        id: 0,
        date: '',
        title: '',
        content: ''
      }
    }
  },
  methods: {
    getSiteData: function () {
      this.$store.state.wait = {state: true, name: 'Формирование страницы'};
      this.$http
      .post(this.$apiold, {
        task: 'site',
        id: this.id
      })
      .then(response => {
        this.site = response.data.result;
        this.$store.state.wait = {state: false};
      });
    }
  },
  created: function () {
    this.getSiteData();
  },
  computed:  {
    ...mapGetters({
      links: 'links'
    })
  },
  watch: {
    id: function () {
      this.getSiteData();
    }
  }

}
</script>


<style>

</style>